import { useQuery } from '@tanstack/react-query';
import { listLookup } from '../api/masterData';

/** The real "New" LeadStatus id, looked up via the same
 * `/master-data/lead-statuses` endpoint the Leads list's own Status
 * filter already uses — never hardcoded. Shared by every dashboard
 * pending-leads click-through (the headline "Pending leads" KPI, "My
 * Pending Leads", "Pending Leads by Counselor") so each one filters the
 * Leads list to `leadStatusId=<this id>` instead of the broader
 * `pending=true`, matching exactly what was counted — the one pending-
 * leads definition those cards' numbers are now built from
 * (dashboard.service.ts's `PENDING_LEAD_BY_COUNSELOR_WHERE`). */
export const useNewLeadStatusId = (): number | undefined => {
  const query = useQuery({
    queryKey: ['lookup', '/master-data/lead-statuses'],
    queryFn: () => listLookup('/master-data/lead-statuses'),
  });
  return query.data?.find((s) => s.name === 'New')?.id as number | undefined;
};
